export default __webpack_public_path__ + "static/media/trashIcon.2ed8bf4b.svg";